import { useContext, useEffect } from "react";
import styles from "./ButtonAdditionalQuestions.module.css";
import DataContext from "../../store/data-context";
import { inherits } from "util";

export default function ButtonAdditionalQuestions({
    children,
    setInHelp,
    selectedAttributes,
    mobileActive = false,
}) {
    return (
        <div
            className={`${styles[`additional-questions`]} ${
                mobileActive && styles[`additional-questions-mobile-active`]
            }`}
            onClick={() =>
                setInHelp({
                    title: "Dodatna pomoć",
                    description: `Ako niste sigurni što odabrati od ponuđenih usluga, označite sljedeće opcije koje opisuju vaše potrebe. Na temelju vaših odgovora, mi ćemo vam ponuditi potrebnu pomoć i pogodnu uslugu. Nakon odabranih željenih pitanja kliknite na gumb "Potvrdi"`,
                    active: true,
                    questions: JSON.parse(JSON.stringify(selectedAttributes)),
                })
            }
        >
            {children}
            <div className={styles[`additional-questions-symbol`]}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                    <line
                        x1="50"
                        y1="20"
                        x2="50"
                        y2="80"
                        stroke="currentColor"
                        strokeWidth="10"
                    />
                    <line
                        x1="20"
                        y1="50"
                        x2="80"
                        y2="50"
                        stroke="currentColor"
                        strokeWidth="10"
                    />
                </svg>
            </div>
        </div>
    );
}
